var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampanaBordes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.29875C11.7166 4.29875 13.3629 4.97297 14.5768 6.17311C15.7906 7.37323 16.4725 9.00095 16.4725 10.6982C16.4725 13.3234 17.006 15.2892 17.6978 16.7348C18.5817 18.5819 19.0236 19.5054 18.999 19.7163C18.9704 19.9626 18.9338 20.0303 18.7519 20.174C18.5959 20.2973 17.8203 20.2973 16.269 20.2973H3.73099C2.17966 20.2973 1.404 20.2973 1.24808 20.174C1.06619 20.0303 1.02964 19.9626 1.00097 19.7163C0.976389 19.5054 1.41833 18.5819 2.30222 16.7348C2.99402 15.2892 3.52751 13.3234 3.52751 10.6982C3.52751 9.00095 4.20943 7.37323 5.42325 6.17311C6.63708 4.97297 8.28335 4.29875 10 4.29875ZM10 4.29875V1.63232M6.82847 24.297C7.67494 25.128 8.78689 25.6323 10.0048 25.6323C11.2226 25.6323 12.3345 25.128 13.1811 24.297",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanaBordes);
export default __webpack_public_path__ + "static/media/CampanaBordes.e2de6dabca4db590a751d798f68bf8c0.svg";
export { ForwardRef as ReactComponent };